<template>
  <div class="locale-changer">
    <div class="current-locale" @click="toggle()">
      {{ $i18n.locale }}
    </div>
    <ul class="avail-locales" :class="{'visible': show}">
      <li v-for="locale in $i18n.availableLocales" :key="`locale-${locale}`" @click="setLocale(locale)">{{ locale }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    }
  },
  methods: {
    toggle() {
      this.show = !this.show
    },
    setLocale(locale) {
      this.$i18n.locale = locale
      this.toggle()
    },
  },
}
</script>

<style scoped>
.locale-changer {
  position: relative;
}
.current-locale {
  cursor: pointer;
  border: 1px solid #ececec;
  border-radius: 4px;
  padding: 4px 12px;
}
.avail-locales {
  display: none;
  list-style: none;
  position: absolute;
  right: 0;
  margin: 0;
  padding: 0;
  border: 1px solid #ececec;
  border-radius: 4px;
  background-color: #fff;
}
.avail-locales li {
  cursor: pointer;
  padding: 4px 16px;
}
.avail-locales li:hover {
  background-color: #ccc;
}
.avail-locales.visible {
  display: block;
}
</style>